import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { useAuth } from "@/lib/auth";

export default function Account() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const info = [
    { k: "Email", v: user.email },
    { k: "Phone", v: user.phone || "—" },
    { k: "Role", v: user.role || "—" },
    { k: "Capital Deployed", v: user.capital_deployed || "—" },
    { k: "Regions", v: (user.regions || []).join(", ") || "—" },
    { k: "Member Since", v: new Date(user.created_at).toLocaleDateString() },
  ];

  return (
    <DashboardLayout>
      <div className="border-b border-border px-6 md:px-10 py-6">
        <div className="overline gold-text">Account</div>
        <h1 className="font-display font-medium text-3xl md:text-4xl tracking-tight mt-1">{user.name || "Your Profile"}</h1>
      </div>

      <div className="px-6 md:px-10 py-8 grid md:grid-cols-2 gap-6 max-w-4xl">
        <div className="card-institutional p-6">
          <div className="overline gold-text">Current Access</div>
          <div className="font-display font-medium text-3xl mt-2 capitalize">{user.tier}</div>
          <p className="text-sm text-muted-foreground mt-2">
            {user.tier === "institutional" ? "Full access to Deal Room and allocation pathways." : user.tier === "professional" ? "Full deal breakdowns + execution pathways." : "Weekly intelligence and standard deal summaries."}
          </p>
          <button onClick={() => navigate("/pricing")} className="btn-primary mt-6" data-testid="account-upgrade-button">
            Manage Access <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="card-institutional p-6">
          <div className="overline">Profile</div>
          <div className="divider my-4" />
          <dl className="space-y-3 text-sm">
            {info.map(({ k, v }) => (
              <div key={k} className="grid grid-cols-[140px_1fr] gap-3">
                <dt className="text-muted-foreground">{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </DashboardLayout>
  );
}
